import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { colors } from "../themes/appTheme";

import CloseIcon from "../assets/icons/CloseIcon";
import Chapters from "./Chapters.js";

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: ${props => (props.isMenuOpen ? 0 : "-300px")};
  overflow: scroll;
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: all 0.15s ease-out;
  width: 300px;
  z-index: 2;
  border-right: 1px solid ${props => props.theme.colors.primaryDarkDim};
  background: ${props => props.theme.colors.primaryDark};
`;

const IconPanel = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-start;
  align-items: center;
  height: 80px;
  padding-left: ${props => props.theme.grid.outerMargin};
  background: ${props => props.theme.colors.primaryDark};
  border-bottom: 1px solid ${props => props.theme.colors.primaryDarkDim};
`;

class MainMenu extends Component {
  static propTypes = {
    isMenuOpen: PropTypes.bool.isRequired,
    onMainMenuToggle: PropTypes.func.isRequired
  };

  render() {
    const { isMenuOpen, onMainMenuToggle } = this.props;

    return (
      <Wrapper isMenuOpen={isMenuOpen}>
        <IconPanel>
          <CloseIcon
            color={colors.primaryDarkLight}
            onClick={onMainMenuToggle}
          />
        </IconPanel>
        <Chapters onMainMenuToggle={onMainMenuToggle} />
      </Wrapper>
    );
  }
}

export default MainMenu;



// WEBPACK FOOTER //
// ./src/menu/MainMenu.js